import React, { useEffect, useState } from 'react';
import api from '../api/api';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Buildings, Warning } from '@phosphor-icons/react';
import { toast } from 'sonner';
import ProfessionChips from './ProfessionChips';

/** Centro: professioni offerte direttamente, per comparire nelle ricerche anche senza organico. */
export const CenterOfferedProfessions = ({ me, professions, onSaved }) => {
  const [value, setValue] = useState(me.offered_profession_codes || []);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setValue(me.offered_profession_codes || []); }, [me.offered_profession_codes]);

  const offered = new Set(me.offered_profession_codes || []);
  const staffCodes = (me.profession_codes || []).filter((c) => !offered.has(c));
  const visible = (me.profession_codes || []).length > 0;
  const dirty = [...value].sort().join() !== [...(me.offered_profession_codes || [])].sort().join();

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/api/professionals/me/offered-professions', { codes: value });
      toast.success('Professioni aggiornate: il Centro compare nelle ricerche per queste prestazioni');
      onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Salvataggio non riuscito'); }
    finally { setSaving(false); }
  };

  return (
    <Card className="rounded-2xl p-4 mb-6" data-testid="center-offered-professions">
      <div className="flex items-center gap-2 mb-1">
        <Buildings size={18} className="text-primary" weight="duotone" />
        <span className="text-sm font-medium">Professioni offerte dal Centro</span>
      </div>
      <p className="text-xs text-foreground/60 mb-3">
        Scegli le prestazioni che il Centro offre: compari nelle ricerche dei clienti anche se non hai ancora professionisti in organico.
        Quelle coperte dal tuo organico si aggiungono da sole.
      </p>
      {!visible && (
        <p className="text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-3 flex items-center gap-2" data-testid="center-not-visible-warning">
          <Warning size={14} weight="fill" /> Il tuo Centro oggi non compare nelle ricerche: scegli almeno una professione.
        </p>
      )}
      <ProfessionChips professions={professions} value={value} onChange={setValue} locked={staffCodes} />
      <Button size="sm" className="rounded-full mt-3" onClick={save} disabled={saving || !dirty} data-testid="center-offered-save">
        {saving ? 'Salvataggio…' : 'Salva professioni'}
      </Button>
    </Card>
  );
};

export default CenterOfferedProfessions;
